// Define props for the Pagination component
interface PaginationProps {
  currentPage: number; // Current active page
  totalItems: number; // Total number of items to paginate
  itemsPerPage: number; // Number of items displayed per page
  onPageChange: (page: number) => void; // Callback for changing pages
}

// Functional Pagination component
export function Pagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}: PaginationProps) {
  // Calculate the total number of pages
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Handler for the "Previous" button
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1); // Trigger onPageChange with the previous page
    }
  };

  // Handler for the "Next" button
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1); // Trigger onPageChange with the next page
    }
  };

  return (
    <div className="flex justify-between mt-8">
      {/* Previous Button */}
      <button
        onClick={handlePrevious}
        className={`px-4 py-2 rounded ${
          currentPage === 1
            ? 'bg-background-light text-text-secondary' // Disabled styling
            : 'bg-primary-main text-white hover:bg-primary-dark' // Enabled styling
        }`}
        disabled={currentPage === 1} // Disable button if on the first page
      >
        Previous
      </button>

      {/* Current Page Indicator */}
      <span className="text-text-secondary">Page {currentPage}</span>

      {/* Next Button */}
      <button
        onClick={handleNext}
        className={`px-4 py-2 rounded ${
          currentPage >= totalPages
            ? 'bg-background-light text-text-secondary' // Disabled styling
            : 'bg-primary-main text-white hover:bg-primary-dark' // Enabled styling
        }`}
        disabled={currentPage >= totalPages} // Disable button if on the last page
      >
        Next
      </button>
    </div>
  );
}
